"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    listboxClassNames: function() {
        return listboxClassNames;
    },
    useListboxStyles_unstable: function() {
        return useListboxStyles_unstable;
    }
});
const _react = require("@griffel/react");
const listboxClassNames = {
    root: 'fui-Listbox'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        De3pzq: "fxugw4r",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        Bf4jedk: "f3hsy1e",
        Bmxbyg5: "f5zp4f",
        Bpd4iqm: "fpvhumw",
        oeaueh: "f1yog68k",
        Bw0xxkn: "f13sgyd8",
        z8tnut: "f1x4af0m",
        z189sj: [
            "f7x41pl",
            "fruq291"
        ],
        Byoj8tv: "fd55psn",
        uwmqm3: [
            "fruq291",
            "f7x41pl"
        ],
        Belr9w4: "fiut8dr"
    }
}, {
    d: [
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f3hsy1e{min-width:160px;}",
        ".f5zp4f{overflow-y:auto;}",
        ".fpvhumw{outline-width:1px;}",
        ".f1yog68k{outline-style:solid;}",
        ".f13sgyd8{outline-color:var(--colorTransparentStroke);}",
        ".f1x4af0m{padding-top:var(--spacingHorizontalXS);}",
        ".f7x41pl{padding-right:var(--spacingHorizontalXS);}",
        ".fruq291{padding-left:var(--spacingHorizontalXS);}",
        ".fd55psn{padding-bottom:var(--spacingHorizontalXS);}",
        ".fiut8dr{row-gap:var(--spacingHorizontalXXS);}"
    ]
});
const useListboxStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(listboxClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useListboxStyles.styles.js.map
